import { styled } from '@mui/material/styles';
import {
  Accordion as MuiAccordion,
  AccordionSummary as MuiAccordionSummary,
  AccordionDetails as MuiAccordionDetails,
} from '@mui/material';

export const Accordion = styled(MuiAccordion)(() => ({
  '&.Mui-expanded': {
    margin: 0,
  },
}));

export const AccordionSummary = styled(MuiAccordionSummary)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderTop: `1px solid ${theme.palette.border.main}`,
  height: '64px',
  minHeight: '64px',
  flexDirection: 'row-reverse',

  '& .MuiAccordionSummary-content': {
    padding: '0 30px 0 5px',
    margin: 0,
    height: '100%',
    display: 'flex',
    alignItems: 'center',

    '&.Mui-expanded': {
      margin: 0,
      padding: '0 30px 0 5px',
    },
  },

  '& .MuiAccordionSummary-expandIconWrapper': {
    marginRight: '12px',
  },
}));

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.border.main}`,
  padding: '24px 0 32px 0',
  backgroundColor: theme.palette.gray.brightGray,
  display: 'flex',
  flexDirection: 'column',
  gap: '32px',
}));
